import { render, staticRenderFns } from "./SurveyResults.vue?vue&type=template&id=226c90c4&"
import script from "./SurveyResults.vue?vue&type=script&lang=js&"
export * from "./SurveyResults.vue?vue&type=script&lang=js&"
import style0 from "./SurveyResults.vue?vue&type=style&index=0&id=226c90c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports